import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { blogs } from "../constants/blogsData";
import "../styles/blogs.css";

const Blogs = () => {
	const navigate = useNavigate();

	return (
		<div className="blog_container">
			{blogs.map((blog) => (
				<div
					key={blog.id}
					className="blog_item"
				>
					<h2>
						<Link to={`/blogs/${blog.id}`}>{blog.title}</Link>
					</h2>
					<p className="blog_date">
					</p>
					<div className="blog_content">
						<div className="blog_info">
							{blog.introduction}
							
							<div
								onClick={() => navigate(`/blogs/${blog.id}`)}
								className="read_more"
							>
								Read more
							</div>
						</div>
						<div className="blog_img_container">
							<img
								src={blog.imageSource}
								alt="blog1"
								width={300}
								height={169}
							/>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default Blogs;
